// === FILE HEADER: VortexIndicator.js ===
// Renders the swirling vortex indicator for empty squares as an absolutely positioned overlay.
// Used by TileLayer in portal-based rendering.
// Last updated: 2025-07-17

import React from 'react';
import pcModule from './VortexIndicator.pc.module.css';
import mobileModule from './VortexIndicator.mobile.module.css';
import useSelectedCssModule from '../hooks/useSelectedCssModule';

function VortexIndicator({ fileRank, className, ...rest }) {
  const styles = useSelectedCssModule(pcModule, mobileModule);
  return (
    <span
      className={styles.vortexIndicatorWrapper}
      data-file-rank={fileRank}
      title="Empty Square"
      {...rest}
    >
      <span className={className || styles.vortexIndicator} />
    </span>
  );
}

export default VortexIndicator;
